import { useState } from 'react';
import {
  Box,
  DialogContent,
  DialogProps,
  DialogTitle,
  FormControlLabel,
  IconButton,
  Radio,
  RadioGroup,
  Stack,
  TextField,
  Typography,
} from '@mui/material';

import { CloseCircleIcon, SearchIcon } from '~assets/icons';
import { FullHeightSlideDialog } from '~components/atoms';
import type { CountryItem } from '~configs';
import useSearchCountry from '~hooks/useSearchCountry';

type Props = DialogProps & {
  onSelected: (country: CountryItem) => void;
  currentValue: CountryItem | undefined;
};

export const CountryCodeSelectionDialog: React.FC<Props> = ({
  onSelected,
  currentValue,
  ...dialogProps
}) => {
  const [search, setSearch] = useState('');
  const countries = useSearchCountry(search);

  return (
    <FullHeightSlideDialog {...dialogProps}>
      <DialogTitle>
        <Typography variant="body2" fontWeight={400}>
          Country/Region
        </Typography>
      </DialogTitle>
      <DialogContent>
        <Box
          display="flex"
          flexDirection="column"
          justifyContent="center"
          alignItems="center"
          gap={2}
        >
          <TextField
            sx={{ width: 1, mt: 1, mb: 1.5 }}
            value={search}
            onChange={(e) => setSearch(e.target.value)}
            InputProps={{
              startAdornment: (
                <Stack marginLeft={1} marginRight={0.5}>
                  <SearchIcon />
                </Stack>
              ),
              endAdornment: search ? (
                <IconButton
                  onClick={() => setSearch('')}
                  edge="end"
                  size="small"
                  sx={{ marginRight: 0.5 }}
                >
                  <CloseCircleIcon />
                </IconButton>
              ) : null,
              sx: {
                borderRadius: 100,
                padding: '5px 0 !important',
              },
            }}
            inputProps={{
              sx: {
                padding: '7px 4px',
              },
              autoComplete: 'off',
            }}
          />
          <RadioGroup
            name="controlled-radio-buttons-group"
            value={`${currentValue?.dialCode}${currentValue?.name}`}
            sx={{ width: 1 }}
          >
            {countries.map((country, index) => (
              <FormControlLabel
                key={index + country.name}
                sx={{
                  '&.MuiFormControlLabel-root': {
                    justifyContent: 'space-between',
                    marginLeft: 0,
                  },
                }}
                labelPlacement="start"
                value={`${country.dialCode}${country.name}`} //Avoid same dialCode or same name case
                control={<Radio />}
                label={`${country.name} (+${country.dialCode})`}
                onChange={() => {
                  onSelected(countries[index]);
                }}
              />
            ))}
          </RadioGroup>
        </Box>
      </DialogContent>
    </FullHeightSlideDialog>
  );
};
